<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="categoria-materia" titulo="Categorías Materias / Coordinación escolar" [dato]="dato" ></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>


<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside ></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- formulario -->
            <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar()" >
                <section class="hero is-primary">
                    <div class="hero-body">

                        <!-- Opciones  -->
                        <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
                    </div>
                </section>

                <section class="section" style="overflow-y:auto; overflow-x:hidden; height: 85.8vh;">
                    <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
                    <a id="catalogos" (click)="ctrl.cargarCatalogo('grupos', 'grupo'); ctrl.cargarCatalogo('periodos_escolares', 'periodo-escolar'); ctrl.cargarCatalogo('carreras_planes', 'carrera-plan');"></a>
                    <div class="field">
                        <label class="label">Nombre:</label>
                        <p class="control has-icons-left has-icons-right">
                            <input class="input" autofocus type="text" [ngClass]="{'is-danger': ctrl.dato.get('nombre').hasError('required')}"
                                placeholder="Nombre" formControlName="nombre">
                            <span class="icon is-small is-right" *ngIf="ctrl.dato.get('nombre').hasError('required')">
                                <i class="fa fa-warning"></i>
                            </span>
                            <span class="help is-danger" *ngIf="ctrl.dato.get('nombre').hasError('required')">Este campo es requerido.</span>
                        </p>
                    </div>

                    <div class="field">
                        <div class="b-checkbox is-info">
                            <input id="activo" class="styled" [checked]="ctrl.dato.get('activo').value == '1' ? true : false"
                                (change)="ctrl.dato.get('activo').patchValue(ctrl.dato.get('activo').value == '1' ? '0' : '1')"
                                type="checkbox">
                            <label for="activo">
                                Activo ( Sólo de debe tener un plan activo)
                            </label>
                        </div>
                    </div>

                    <!-- <div class="field">
                        <h2>Construyendo...</h2>
                    </div> -->
                    <!--<div class="field">
                        <label class="label">Nivel:</label>
                        <p class="control has-icons-left has-icons-right">
                            <input class="input"  type="text" [ngClass]="{'is-danger': ctrl.dato.get('nivel').hasError('required')}"
                                placeholder="Nivel" formControlName="nivel">
                            <span class="icon is-small is-right" *ngIf="ctrl.dato.get('nivel').hasError('required')">
                                <i class="fa fa-warning"></i>
                            </span>
                            <span class="help is-danger" *ngIf="ctrl.dato.get('nivel').hasError('required')">Este campo es requerido.</span>
                        </p>
                    </div>

                    <div class="field">
                        <label class="label">Periodo Escolar:</label>
                        <div class="control has-icons-left has-icons-right">
                            <div class="select" [ngClass]="{'is-danger': ctrl.dato.get('periodos_escolares_id').hasError('required')}">
                                <select class="select" name="periodos_escolares_id" formControlName="periodos_escolares_id">
                                    <option *ngFor="let val of ctrl.periodos_escolares" value="{{val.id}}">{{ val.nombre }}</option>
                                </select>
                            </div>
                            <span class="icon is-small is-right" *ngIf="ctrl.dato.get('periodos_escolares_id').hasError('required')">
                                <i class="fa fa-warning"></i>
                            </span>
                            <span class="help is-danger" *ngIf="ctrl.dato.get('periodos_escolares_id').hasError('required')">Este campo es requerido.</span>
                        </div>
                    </div>

                    <div class="field">
                        <label class="label">Plan:</label>
                        <div class="control has-icons-left has-icons-right">
                            <div class="select" [ngClass]="{'is-danger': ctrl.dato.get('carreras_planes_id').hasError('required')}">
                                <select class="select" name="carreras_planes_id" formControlName="carreras_planes_id">
                                    <option *ngFor="let val of ctrl.carreras_planes" value="{{val.id}}">{{ val.carreras.nombre }} / {{ val.planes_estudios.nombre }}</option>
                                </select>
                            </div>
                            <span class="icon is-small is-right" *ngIf="ctrl.dato.get('carreras_planes_id').hasError('required')">
                                <i class="fa fa-warning"></i>
                            </span>
                            <span class="help is-danger" *ngIf="ctrl.dato.get('carreras_planes_id').hasError('required')">Este campo es requerido.</span>
                        </div>
                    </div>

                    <div class="field">
                        <label class="label">Observaciones:</label>
                        <p class="control has-icons-left has-icons-right">
                            <textarea class="input" type="text" placeholder="Observaciones" formControlName="observaciones"></textarea>
                        </p>
                    </div>-->

                </section>
            </form>
        </div>
    </div>
</div>
